import { css } from '@emotion/css';

export const logoStyles = css`
  width: 7.12rem; // Since the logo width / height is 89 / 30, to prevent shrinking when width is 24
`;
